<section class="sme-dashboard">
  @if (!isLoading) {
    <div class="cta-container">
      <div class="cta-content">
        <span class="cta-badge">Share your business needs</span>
        <h2 class="cta-title">Have a funding need or business idea?</h2>
        <p class="cta-description">
          Tell Organizations about your business goals, funding requirements,
          and growth plans to connect with the right partners.
        </p>
      </div>
      <div class="cta-action">
        <button
          type="button"
          class="action-btn"
          (click)="navigateTo('/business')"
        >
          Add Request
        </button>
      </div>
    </div>

    <div class="metrics-grid">
      <div
        class="metric-card"
        [class.has-open-tooltip]="activeTooltip === 'orgs-assigned'"
        id="tour-organizations-assigned"
      >
        <svg
          class="metric-icon cdfi-icon"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z"
            fill="currentColor"
          />
        </svg>
        <div class="metric-content">
          <span class="metric-value">{{
            summary?.assigned_cdfi_count || 0
          }}</span>
          <span class="metric-label">ORGANIZATIONS ASSIGNED</span>
        </div>
        <div class="metric-info-wrap">
          <button
            class="info-btn"
            type="button"
            aria-label="More info"
            (click)="toggleTooltip('orgs-assigned', $event)"
          >
            <svg
              viewBox="0 0 24 24"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
              />
            </svg>
          </button>
          @if (activeTooltip === "orgs-assigned") {
            <div class="info-tooltip">
              <span class="tooltip-title">Organizations Assigned</span>
              <p>
                The number of Organizations (CDFIs, lenders, or support
                organizations) that have been assigned to your business profile.
                These organizations may review your needs and reach out to
                support you.
              </p>
            </div>
          }
        </div>
      </div>

      <div
        class="metric-card"
        id="tour-organizations-funded"
        [class.has-open-tooltip]="activeTooltip === 'orgs-funded'"
      >
        <svg
          class="metric-icon funded-icon"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 11.24V7.5C9 6.12 10.12 5 11.5 5S14 6.12 14 7.5v3.74c1.21-.81 2-2.18 2-3.74C16 5.01 13.99 3 11.5 3S7 5.01 7 7.5c0 1.56.79 2.93 2 3.74zm9.84 4.63l-4.54-2.26c-.17-.07-.35-.11-.54-.11H13v-6c0-.83-.67-1.5-1.5-1.5S10 6.67 10 7.5v10.74l-3.43-.72c-.08-.01-.15-.03-.24-.03-.31 0-.59.13-.79.33l-.79.8 4.94 4.94c.27.27.65.44 1.06.44h6.79c.75 0 1.33-.55 1.44-1.28l.75-5.27c.01-.07.02-.14.02-.2 0-.62-.38-1.16-.91-1.38z"
            fill="currentColor"
          />
        </svg>
        <div class="metric-content">
          <span class="metric-value">{{
            summary?.funded_status?.funded_cdfi_count || 0
          }}</span>
          <span class="metric-label">ORGANIZATIONS FUNDED</span>
        </div>
        <div class="metric-info-wrap">
          <button
            class="info-btn"
            type="button"
            aria-label="More info"
            (click)="toggleTooltip('orgs-funded', $event)"
          >
            <svg
              viewBox="0 0 24 24"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
              />
            </svg>
          </button>
          @if (activeTooltip === "orgs-funded") {
            <div class="info-tooltip">
              <span class="tooltip-title">Organizations Funded</span>
              <p>
                The number of Organizations that have indicated they have
                provided or committed funding to your business. This reflects
                successful funding connections made through the platform.
              </p>
            </div>
          }
        </div>
      </div>

      <div
        class="metric-card"
        id="tour-total-funded"
        [class.has-open-tooltip]="activeTooltip === 'total-funded'"
      >
        <svg
          class="metric-icon funding-icon"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13.41 18.09V20H10.74V18.07C9.03 17.77 7.58 16.73 7.32 14.97H9.14C9.32 16.02 10.07 16.69 11.97 16.69C14.05 16.69 14.54 15.72 14.54 15.03C14.54 14.14 14.04 13.38 11.5 12.82C8.63 12.18 7.08 11.13 7.08 9.01C7.08 7.35 8.36 6.13 10.74 5.76V4H13.41V5.78C15.54 6.23 16.38 7.68 16.5 9.16H14.67C14.57 8.12 14.03 7.3 11.97 7.3C10.12 7.3 9.42 8.08 9.42 8.95C9.42 9.75 10.03 10.32 12.36 10.84C14.69 11.36 16.88 12.19 16.88 15.06C16.87 16.8 15.59 17.93 13.41 18.09Z"
            fill="currentColor"
          />
        </svg>
        <div class="metric-content">
          <span class="metric-value">{{
            summary?.funded_status?.funded_amount || 0
              | currency: "USD" : "symbol" : "1.0-0"
          }}</span>
          <span class="metric-label">TOTAL FUNDED</span>
        </div>
        <div class="metric-info-wrap">
          <button
            class="info-btn"
            type="button"
            aria-label="More info"
            (click)="toggleTooltip('total-funded', $event)"
          >
            <svg
              viewBox="0 0 24 24"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
              />
            </svg>
          </button>
          @if (activeTooltip === "total-funded") {
            <div class="info-tooltip">
              <span class="tooltip-title">Total Funded</span>
              <p>
                The cumulative dollar amount of funding that has been committed
                or disbursed to your business through partnerships formed on
                this platform. This reflects the financial impact of your
                connections.
              </p>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="engagement-container">
      <div class="card-header">
        <div>
          <h3>Engagement Metrics</h3>
          <span class="engagement-badge"
            >How organizations interact with you</span
          >
        </div>
      </div>
      <div class="engagement-grid">
        <!-- Profile Views Card -->
        <div class="engagement-card profile-views-card" id="tour-profile-views">
          <div class="engagement-card-body">
            <div class="engagement-card-header">
              <div class="engagement-icon-wrap profile-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"
                  />
                </svg>
              </div>
              <div class="engagement-card-title-wrap">
                <span class="engagement-title">Profile Views</span>
                <span class="engagement-subtitle"
                  >Your personal profile engagement</span
                >
              </div>
              <div class="metric-info-wrap">
                <button
                  class="info-btn"
                  type="button"
                  aria-label="More info about profile views"
                  (click)="toggleTooltip('profile-views', $event)"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
                    />
                  </svg>
                </button>
                @if (activeTooltip === "profile-views") {
                  <div class="info-tooltip tooltip-left">
                    <span class="tooltip-title">Profile Views Explained</span>
                    <p>
                      This counts how many times organizations and their team
                      members have viewed your personal profile. A higher count
                      means more organizations are interested in learning about
                      you.
                    </p>
                  </div>
                }
              </div>
            </div>

            <div class="engagement-stats-row">
              <div class="engagement-stat-block">
                <span class="engagement-stat-num">{{
                  summary?.profile_views?.user_view_count || 0
                }}</span>
                <span class="engagement-stat-label">
                  <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    class="stat-mini-icon"
                  >
                    <path
                      d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"
                    />
                  </svg>
                  {{
                    summary?.profile_views?.user_view_count === 1
                      ? "User"
                      : "Users"
                  }}
                </span>
              </div>
              <div class="engagement-stat-divider">from</div>
              <div class="engagement-stat-block">
                <span class="engagement-stat-num accent">{{
                  summary?.profile_views?.cdfi_view_count || 0
                }}</span>
                <span class="engagement-stat-label">
                  <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    class="stat-mini-icon"
                  >
                    <path
                      d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
                    />
                  </svg>
                  {{
                    summary?.profile_views?.cdfi_view_count === 1
                      ? "Organization"
                      : "Organizations"
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Business Views Card -->
        <div
          class="engagement-card business-views-card"
          id="tour-business-views"
        >
          <div class="engagement-card-body">
            <div class="engagement-card-header">
              <div class="engagement-icon-wrap business-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20 7H16V5C16 3.9 15.1 3 14 3H10C8.9 3 8 3.9 8 5V7H4C2.9 7 2 7.9 2 9V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V9C22 7.9 21.1 7 20 7ZM10 5H14V7H10V5Z"
                  />
                </svg>
              </div>
              <div class="engagement-card-title-wrap">
                <span class="engagement-title">Business Views</span>
                <span class="engagement-subtitle"
                  >Your business request engagement</span
                >
              </div>
              <div class="metric-info-wrap">
                <button
                  class="info-btn"
                  type="button"
                  aria-label="More info about business views"
                  (click)="toggleTooltip('business-views', $event)"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
                    />
                  </svg>
                </button>
                @if (activeTooltip === "business-views") {
                  <div class="info-tooltip tooltip-left">
                    <span class="tooltip-title">Business Views Explained</span>
                    <p>
                      This shows how many times organizations and their members
                      have reviewed your business funding requests and needs. It
                      indicates how actively lenders and partners are evaluating
                      your business.
                    </p>
                  </div>
                }
              </div>
            </div>

            <div class="engagement-stats-row">
              <div class="engagement-stat-block">
                <span class="engagement-stat-num">{{
                  summary?.business_views?.user_view_count || 0
                }}</span>
                <span class="engagement-stat-label">
                  <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    class="stat-mini-icon"
                  >
                    <path
                      d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"
                    />
                  </svg>
                  {{
                    summary?.business_views?.user_view_count === 1
                      ? "User"
                      : "Users"
                  }}
                </span>
              </div>
              <div class="engagement-stat-divider">from</div>
              <div class="engagement-stat-block">
                <span class="engagement-stat-num accent">{{
                  summary?.business_views?.cdfi_view_count || 0
                }}</span>
                <span class="engagement-stat-label">
                  <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    class="stat-mini-icon"
                  >
                    <path
                      d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
                    />
                  </svg>
                  {{
                    summary?.business_views?.cdfi_view_count === 1
                      ? "Organization"
                      : "Organizations"
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="activity-log-card" id="tour-recent-activity">
      <div class="activity-card-header">
        <div class="activity-header-left">
          <div class="activity-title-row">
            <h3 class="activity-heading">Recent Activity</h3>
            <div class="live-indicator">
              <span class="pulse-dot"></span>
              <span class="indicator-text">Live Updates</span>
            </div>
          </div>
          <span class="activity-subtitle"
            >Track updates, views, and milestones for your business</span
          >
        </div>
        <div class="milestone-progress-wrap">
          <div class="milestone-progress-label">
            <span class="milestone-progress-count">{{
              activityLog.length
            }}</span>
            <span class="milestone-progress-text"
              >milestone{{ activityLog.length === 1 ? "" : "s" }} reached</span
            >
          </div>
          <div class="milestone-progress-bar">
            <div
              class="milestone-progress-fill"
              [style.width.%]="(activityLog.length / 5) * 100"
            ></div>
          </div>
        </div>
      </div>

      <div class="activity-cards-grid">
        @for (log of activityLog; track log.title; let i = $index) {
          <div class="activity-card" [class]="'activity-card--' + log.type">
            <div class="activity-card-accent"></div>
            <div class="activity-card-body">
              <div class="activity-card-top">
                <div
                  class="activity-icon-bubble"
                  [class]="'bubble--' + log.type"
                >
                  @switch (log.icon) {
                    @case ("verified") {
                      <svg
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        class="activity-icon"
                      >
                        <path
                          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                        />
                      </svg>
                    }
                    @case ("business") {
                      <svg
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        class="activity-icon"
                      >
                        <path
                          d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
                        />
                      </svg>
                    }
                    @case ("pending") {
                      <svg
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        class="activity-icon"
                      >
                        <path
                          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 14h-2v-2h2v2zm0-4h-2V7h2v5z"
                        />
                      </svg>
                    }
                    @case ("scan") {
                      <svg
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        class="activity-icon"
                      >
                        <path
                          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"
                        />
                      </svg>
                    }
                    @case ("views") {
                      <svg
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        class="activity-icon"
                      >
                        <path
                          d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                        />
                      </svg>
                    }
                    @case ("assignment") {
                      <svg
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        class="activity-icon"
                      >
                        <path
                          d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
                        />
                      </svg>
                    }
                    @case ("dollar") {
                      <svg
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        class="activity-icon"
                      >
                        <path
                          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"
                        />
                      </svg>
                    }
                    @default {
                      <svg
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        class="activity-icon"
                      >
                        <path
                          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
                        />
                      </svg>
                    }
                  }
                </div>
                <div class="activity-badge" [class]="'badge--' + log.type">
                  {{ log.timestamp }}
                </div>
              </div>
              <div class="activity-card-content">
                <span class="activity-card-title">{{ log.title }}</span>
                <p class="activity-card-desc">{{ log.description }}</p>
              </div>
              @if (log.actionLabel && log.actionRoute) {
                <button
                  type="button"
                  class="activity-action-btn"
                  [class]="'action-btn--' + log.type"
                  (click)="navigateTo(log.actionRoute)"
                >
                  {{ log.actionLabel }}
                  <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="action-arrow"
                  >
                    <path
                      d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
                    />
                  </svg>
                </button>
              }
            </div>
          </div>
        }
      </div>
    </div>
  } @else {
    <app-skeleton [type]="'sme-dashboard'"></app-skeleton>
  }
</section>
